module.exports = __webpack_public_path__ + "img/ciaz-plata-mercurio.63a62824.png";